/**
 * Valores fallback para configurações de UI
 * Usados quando a API não está disponível
 */

import type { 
  CategoryColorConfig, 
  FolderColorConfig,
  AnnotationColorConfig,
  AnnotationCategoryConfig 
} from '../types/settings'

export const CATEGORY_COLORS_FALLBACK: CategoryColorConfig[] = [
  {
    category: 'processual',
    backgroundColor: '#e3f2fd',
    textColor: '#1565c0',
    label: 'Processual'
  },
  {
    category: 'penal',
    backgroundColor: '#fce4ec',
    textColor: '#c62828',
    label: 'Penal'
  },
  {
    category: 'civel',
    backgroundColor: '#e8f5e9',
    textColor: '#2e7d32',
    label: 'Cível'
  },
  {
    category: 'constitucional',
    backgroundColor: '#fff3e0',
    textColor: '#e65100',
    label: 'Constitucional'
  },
  {
    category: 'trabalhista',
    backgroundColor: '#f3e5f5',
    textColor: '#7b1fa2',
    label: 'Trabalhista'
  },
  {
    category: 'geral',
    backgroundColor: '#eceff1',
    textColor: '#455a64',
    label: 'Geral'
  }
]

export const FOLDER_COLORS_FALLBACK: FolderColorConfig[] = [
  { value: '#90CAF9', label: 'Azul claro' },
  { value: '#1976d2', label: 'Azul' },
  { value: '#66BB6A', label: 'Verde' },
  { value: '#FFA726', label: 'Laranja' },
  { value: '#EF5350', label: 'Vermelho' },
  { value: '#AB47BC', label: 'Roxo' },
  { value: '#78909C', label: 'Cinza' },
  { value: '#FFD54F', label: 'Amarelo' },
  { value: '#4DB6AC', label: 'Teal' },
  { value: '#F06292', label: 'Rosa' }
]

export const ANNOTATION_COLORS_FALLBACK: AnnotationColorConfig[] = [
  {
    color: 'yellow',
    backgroundColor: '#fff9c4',
    borderColor: '#fbc02d',
    label: 'Amarelo'
  },
  {
    color: 'green',
    backgroundColor: '#c8e6c9',
    borderColor: '#388e3c',
    label: 'Verde'
  },
  {
    color: 'blue',
    backgroundColor: '#bbdefb',
    borderColor: '#1976d2',
    label: 'Azul'
  },
  {
    color: 'red',
    backgroundColor: '#ffcdd2',
    borderColor: '#d32f2f',
    label: 'Vermelho'
  },
  {
    color: 'purple',
    backgroundColor: '#e1bee7',
    borderColor: '#7b1fa2',
    label: 'Roxo'
  }
]

export const ANNOTATION_CATEGORIES_FALLBACK: AnnotationCategoryConfig[] = [
  { code: 'note', icon: '📝', label: 'Nota' },
  { code: 'question', icon: '❓', label: 'Questão' },
  { code: 'important', icon: '⚠️', label: 'Importante' },
  { code: 'todo', icon: '✅', label: 'A Fazer' },
  { code: 'reference', icon: '🔗', label: 'Referência' }
]

export const AUDIO_EXTENSIONS_FALLBACK: string[] = [
  'mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac', 'wma', 
  'opus', 'webm', 'aiff', 'ape', 'alac', 'amr', 'au'
]

export const VIDEO_EXTENSIONS_FALLBACK: string[] = [
  'mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm',
  'm4v', 'mpg', 'mpeg', '3gp', 'ogv', 'ts', 'vob', 'divx'
]
